exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SessionEditor-module__wrapper___3544h{display:grid;gap:1rem}.SessionEditor-module__wrapper___3544h .SessionEditor-module__add-lesson___TMMvU{background-color:#fff;padding:1rem;border-radius:17px}.SessionEditor-module__wrapper___3544h .SessionEditor-module__add-lesson___TMMvU p{font-size:14px;color:#b4bac3;text-align:center;margin-bottom:1.25rem}", ""]);

// exports
exports.locals = {
	"wrapper": "SessionEditor-module__wrapper___3544h",
	"add-lesson": "SessionEditor-module__add-lesson___TMMvU"
};